<template>
  <div id="about">

    <div class="hidden-sm-and-down">
      <PageHeader/>
    </div>
    <div class="hidden-md-and-up">
      <m-top/>
    </div>

    <div class="hidden-xs-only">
      <el-row type="flex" justify="center">
        <el-col :md="20" :lg="18" :xl="15">
          <div style="width: 100%; max-width: 1284px; margin: 0 auto; min-height:calc(100vh - 160px - 272px);" >
            <div class="clinic-info">

              <!-- <div class="title">ごあいさつ</div>
              <div class="introduction">
                <div>
                  　院長の太田惠一朗です。現在考えられるベストの治療方針をお示しし、治療にあたります。 どんな時も前向きに、共に歩みましょう。 私は今まで長年にわたり、消化器腫瘍外科医（がんの専門医）として、胃がん、食道がん、大腸がんなど、特に進行した患者さんの外科治療と薬物療法に携わってまいりました。 そうした中で、支持療法を含む早期からの緩和医療・ケアや栄養治療の重要性を説きながら、多職種によるチーム医療を実践してきました。 これからは、その経験と知識を活かしながら、地域にあって、広く消化器疾患を有する方々の診療に当たるつもりでいます。 もちろん、必要に応じて、自ら外科治療に参加することも可能です。<br />
                  　情報があふれる昨今、誤った判断に振り回されたり、不安を増長されたりしている患者さんやご家族に、現在考えられるベストの治療方針を客観的に示したいと思います。 あなたを慰め、あなたの苦痛を和らげ、あなたの病を癒すことに尽くします。 共に歩みましょう。 どんな時も、常に前向き思考（志向）で行きましょう。 どうぞお気軽にご相談ください
                </div>
              </div> -->
              <div class="title">{{ t.greetTitle }}</div>
              <div class="doctor_greeting">
                <div class="side-text">
                  <div class="greeting">
                    {{ t.greetingPc }}
                  </div>
                </div>

              </div>

              <div class="title">{{ t.chairmanTitle }}</div>
              <div class="doctor">
                <div class="photo">
                  <div>
                    <img src="../assets/about/img_takashi.png" alt="">
                  </div>
                  <div class="position">{{ t.chairmanPos }}</div>
                  <div class="divider"></div>
                  <div class="name">{{ t.kamigakiName }}</div>
                  <div class="name-en">{{ t.kamigakiSub }}</div>
                  <!-- <div class="profile-detail">
                    <div>専門分野</div>
                    <div>消化器腫瘍外科学（胃癌、食道癌、大腸癌など）</div>
                    <div>学位</div>
                    <div>医学博士（日本大学第5820号）</div>
                    <div>胃癌におけるCisplatinの腹腔内投与時の薬物動態に関する検討</div>
                  </div> -->
                </div>
                <div class="profile">
                  <div class="experience">{{ t.careerTitle }}</div>
                  <div class="detail ll">
                    <template v-for="(row, i) in t.kamigakiCareer">
                      <div :key="'ky' + i">{{ row.y }}</div>
                      <div :key="'kd' + i">{{ row.d[0] }}<template v-if="row.d[1]"><br>{{ row.d[1] }}</template></div>
                    </template>

                  </div>
                  <div class="experience">{{ t.specialtyTitle }}</div>
                  <div class="sennmonn">
                    <div>{{ t.kamigakiSpecialty }}</div>
                  </div>
                    <!-- <div class="society">役　職</div>
                  <div class="society-detail">
                    <div>日本胃癌学会特別会員</div>
                    <div>日本外科学会指導医、専門医、認定医</div>
                    <div>日本消化器外科学会指導医、専門医、認定医</div>
                    <div>日本臨床外科学会特別会員</div>
                    <div>消化器がん外科治療認定医</div>
                    <div>日本外科系連合学会フェロー会員、評議員</div>
                    <div>日本癌治療学会臨床試験登録医</div>
                    <div>日本がん治療認定医機構認定医、暫定教育医</div>
                    <div>日本リンパ学会理事、評議員</div>
                    <div>日本緩和医療学会、暫定指導医</div>
                    <div>日本死の臨床研究会世話人</div>
                    <div>癌とリンパ節研究会幹事</div>
                    <div>CART研究会代表世話人</div>
                    <div>外科漢方フォーラム名誉会員</div>
                    <div>手術手技研究会特別会員</div>
                    <div>日本音楽医療研究会世話人</div>
                    <div>胃外科・術後障害研究会特別会員</div>
                  </div> -->
                </div>
              </div>

              <div class="title">{{ t.directorTitle }}</div>
              <div class="doctor">
                <div class="photo">
                  <div>
                    <!-- <img src="../assets/about/img_ota.png" alt=""> -->
                  </div>
                  <div class="position">{{ t.directorPos }}</div>
                  <div class="divider"></div>
                  <div class="name">{{ t.nakazawaName }}</div>
                  <div class="name-en">{{ t.nakazawaSub }}</div>
                  <!-- <div class="profile-detail">
                    <div>専門分野</div>
                    <div>消化器腫瘍外科学（胃癌、食道癌、大腸癌など）</div>
                    <div>学位</div>
                    <div>医学博士（日本大学第5820号）</div>
                    <div>胃癌におけるCisplatinの腹腔内投与時の薬物動態に関する検討</div>
                  </div> -->
                </div>
                <div class="profile">
                  <div class="experience">{{ t.careerTitle }}</div>
                  <div class="detail ll">
                    <template v-for="(row, i) in t.nakazawaCareer">
                      <div :key="'ny' + i">{{ row.y }}</div>
                      <div :key="'nd' + i">{{ row.d[0] }}</div>
                    </template>
                    <!-- <div>1978年 3月</div>
                    <div>鹿児島大学医学部卒業</div>
                    <div>1978年 4月</div>
                    <div>虎の門病院外科病棟医</div>
                    <div>1982年 6月</div>
                    <div>国立がんセンターレジデント（外科）</div>
                    <div>1985年 6月</div>
                    <div>（財）癌研究会附属病院外科医員</div>
                    <div>1999年 4月</div>
                    <div>同上医長昇任</div>
                    <div>2003年 6月</div>
                    <div>筑波大学大学院人間総合科学研究科臨床医学系外科講師</div>
                    <div>2006年 1月</div>
                    <div>国際医療福祉大学三田病院外科・消化器センター教授</div>
                    <div>2012年 4月</div>
                    <div>湘南鎌倉総合病院副院長、オンコロジーセンター長</div>
                    <div>2013年 10月</div>
                    <div>聖路加国際病院消化器センター長、消化器・一般外科部長</div>
                    <div>2015年 12月</div>
                    <div>日本医科大学消化器外科教授</div>
                    <div>2019年 4月</div>
                    <div>TKC東京クリニック院長</div>
                    <div>2020年 10月</div>
                    <div>医療法人社団天裕会理事長</div>
                    <div>2021年 1月</div>
                    <div>のぞみクリニック学芸大院長</div>
                    <div>2021年 10月</div>
                    <div>のぞみクリニック築地院長</div> -->
                  </div>
                  <!-- <div class="society">役　職</div>
                  <div class="society-detail">
                    <div>日本胃癌学会特別会員</div>
                    <div>日本外科学会指導医、専門医、認定医</div>
                    <div>日本消化器外科学会指導医、専門医、認定医</div>
                    <div>日本臨床外科学会特別会員</div>
                    <div>消化器がん外科治療認定医</div>
                    <div>日本外科系連合学会フェロー会員、評議員</div>
                    <div>日本癌治療学会臨床試験登録医</div>
                    <div>日本がん治療認定医機構認定医、暫定教育医</div>
                    <div>日本リンパ学会理事、評議員</div>
                    <div>日本緩和医療学会、暫定指導医</div>
                    <div>日本死の臨床研究会世話人</div>
                    <div>癌とリンパ節研究会幹事</div>
                    <div>CART研究会代表世話人</div>
                    <div>外科漢方フォーラム名誉会員</div>
                    <div>手術手技研究会特別会員</div>
                    <div>日本音楽医療研究会世話人</div>
                    <div>胃外科・術後障害研究会特別会員</div>
                  </div> -->
                </div>
              </div>

              

              <div class="facility">
                <div class="title">{{ t.facilityTitle }}</div>
                  <ul class="introduce-wrap">
                    <li class="introduce">
                      <div class="img"><img src="@/assets/about/img_hope01.png" :alt="t.reception" height="400"></div>
                      <div class="text">{{ t.reception }}</div>
                    </li>
                    <li class="introduce">
                      <div class="img"><img src="@/assets/about/img_hope02.png" :alt="t.examRoom" height="400"></div>
                      <div class="text">{{ t.examRoom }}</div>
                    </li>
                  </ul>
                  <ul class="introduce-wrap">
                    <li class="introduce">
                      <div class="img"><img src="@/assets/about/img_hope03.png" :alt="t.bloodRoom" height="400"></div>
                      <div class="text">{{ t.bloodRoom }}</div>
                    </li>
                  </ul>
              </div>

            </div>
          </div>
        </el-col>
      </el-row>

      <home-access :show-buttons="false"/>

      <PageFooter :show-list="false"/>

    </div>

    <div class="hidden-sm-and-up">
      <!-- <div>
        <div class="m-tittle">ごあいさつ</div>
        <div class="m-detail">
          <div>院長の太田惠一朗です。現在考えられるベストの治療方針をお示しし、治療にあたります。 どんな時も前向きに、共に歩みましょう。 私は今まで長年にわたり、消化器腫瘍外科医（がんの専門医）として、胃がん、食道がん、大腸がんなど、特に進行した患者さんの外科治療と薬物療法に携わってまいりました。 そうした中で、支持療法を含む早期からの緩和医療・ケアや栄養治療の重要性を説きながら、多職種によるチーム医療を実践してきました。 これからは、その経験と知識を活かしながら、地域にあって、広く消化器疾患を有する方々の診療に当たるつもりでいます。 もちろん、必要に応じて、自ら外科治療に参加することも可能です。</div>
          <div>情報があふれる昨今、誤った判断に振り回されたり、不安を増長されたりしている患者さんやご家族に、現在考えられるベストの治療方針を客観的に示したいと思います。 あなたを慰め、あなたの苦痛を和らげ、あなたの病を癒すことに尽くします。 共に歩みましょう。 どんな時も、常に前向き思考（志向）で行きましょう。 どうぞお気軽にご相談ください</div>
        </div>
      </div> -->
      <div>
        <div class="m-tittle">{{ t.aboutTitle }}</div>
        <div class="m-doctor">
            <div class="m-subTittle">{{ t.greetTitle }}</div>
              <div class="m_greeting">
                {{ t.greetingM }}
              </div>
        </div>
      </div>

      <div>
        <div class="m-tittle">{{ t.chairmanTitle }}</div>
        <div class="m-doctor">
          <div class="m-photo">
            <img src="../assets/about/img_takashi.png" alt="">
            <div class="position">{{ t.chairmanPos }}</div>
            <div class="divider"></div>
            <div class="name">{{ t.kamigakiName }}</div>
            <div class="name-en">{{ t.kamigakiSub }}</div>
          </div>
          <div>
            <div class="m-subTittle">{{ t.careerTitle }}</div>
            <div class="sub-experience ll">
              <template v-for="(row, i) in t.kamigakiCareer">
                <div :key="'mky' + i">{{ row.y }}</div>
                <div :key="'mkd' + i">{{ row.d[0] }}<template v-if="row.d[1]"><br>{{ row.d[1] }}</template></div>
              </template>
            </div>
            <div class="m-subTittle">{{ t.specialtyTitle }}</div>
              <div class="sennmonn">
              <div>{{ t.kamigakiSpecialty }}</div>
            </div>
          </div>
        </div>
        <div class="m-tittle">{{ t.directorTitle }}</div>
        <div class="m-doctor">
          <div class="m-photo">
            <!-- <img src="../assets/about/img_ota.png" alt=""> -->
            <div class="position">{{ t.directorPos }}</div>
            <div class="divider"></div>
            <div class="name">{{ t.nakazawaName }}</div>
            <div class="name-en">{{ t.nakazawaSub }}</div>
            <!-- <div class="profile-detail">
              <div>専門分野</div>
              <div>消化器腫瘍外科学（胃癌、食道癌、大腸癌など）</div>
              <div>学位</div>
              <div>医学博士（日本大学第5820号）</div>
              <div>胃癌におけるCisplatinの腹腔内投与時の薬物動態に関する検討</div>
            </div> -->
          </div>           
          <div>
            <div class="m-subTittle">{{ t.careerTitle }}</div>
            <div class="sub-experience ll">
              <template v-for="(row, i) in t.nakazawaCareer">
                <div :key="'mny' + i">{{ row.y }}</div>
                <div :key="'mnd' + i">{{ row.d[0] }}</div>
              </template>
              <!-- <div>1978年03月</div>
              <div>鹿児島大学医学部卒業</div>
              <div>1978年04月</div>
              <div>虎の門病院外科病棟医</div>
              <div>1982年06月</div>
              <div>国立がんセンターレジデント（外科）</div>
              <div>1985年06月</div>
              <div>（財）癌研究会附属病院外科医員</div>
              <div>1999年04月</div>
              <div>同上医長昇任</div>
              <div>2003年06月</div>
              <div>筑波大学大学院人間総合科学研究科臨床医学系外科講師</div>
              <div>2006年01月</div>
              <div>国際医療福祉大学三田病院外科・消化器センター教授</div>
              <div>2012年04月</div>
              <div>湘南鎌倉総合病院副院長、オンコロジーセンター長</div>
              <div>2013年10月</div>
              <div>聖路加国際病院消化器センター長、消化器・一般外科部長</div>
              <div>2015年12月</div>
              <div>日本医科大学消化器外科教授</div>
              <div>2019年04月</div>
              <div>TKC東京クリニック院長</div>
              <div>2020年10月</div>
              <div>医療法人社団天裕会理事長</div>
              <div>2021年01月</div>
              <div>のぞみクリニック学芸大院長</div>
              <div>2021年10月</div>
              <div>のぞみクリニック築地院長</div> -->
            </div>
          </div>
        </div>

      </div>

      <div>
        <div class="m-tittle">{{ t.facilityTitle }}</div>
        <van-swipe :loop="true" :width="pageWidth" autoplay="5000" :duration="1000">
          <van-swipe-item v-for="item in cardList"v-bind:key="item.id">
            <div class="card">
              <div class="pic"><el-image :src="require(`@/assets/about/${item.picUrl}`)"/></div>
              <div class="sub-name">{{item.name}}</div>
              <div class="detail">
                <div v-for="detail in item.details">{{detail}}</div>
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>

        <m-access :show-buttons="false"/>
        <m-footer/>
      </div>

  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader";
import PageFooter from "@/components/PageFooter";
import HomeAccess from "@/components/home/HomeAccess";
import MTop from "../components/m/MTop";
import MIntroduce from "../components/m/MIntroduce";
import MAccess from "../components/m/MAccess";
import MFooter from "../components/m/MFooter";

// 表示テキスト（ja はこれまでの表示と同一）
const T = {
  ja: {
    aboutTitle: '当院について',
    greetTitle: 'ごあいさつ',
    greetingPc: '当院は令和3（2021）年10月に開業しました。一般内科として適切な医療を受けるための最初の窓口としての役割を担うため、地域の皆様の“かかりつけ医”となれるよう、親身で丁寧な初期診療を心がけております。中央区築地という地域特性上、様々な背景をお持ちの方が受診されます。患者さん個々の背景に応じた治療対応を提供できるように努力しております。診察時の疑問や不安なことだけでなく、どんな些細なことでも構いませんのでお気軽にご相談ください。',
    greetingM: '当院は令和3（2021）年10月に開業しました。一般内科として適切な医療を受けるための最初の窓口としての役割を担うため、地域の皆様の“かかりつけ医“となれるよう、親身で丁寧な初期診療を心がけております。中央区築地という地域特性上、様々な背景をお持ちの方が受診されます。患者さん個々の背景に応じて治療対応を提供できるように努力しております。診察時の疑問や不安なことだけでなく、どんな些細なことでも構いませんのでお気軽にご相談ください。',
    chairmanTitle: '理事長の紹介',
    chairmanPos: '理事長',
    kamigakiName: '神垣 隆',
    kamigakiSub: 'Takashi Kamigaki',
    directorTitle: '院長の紹介',
    directorPos: '院長',
    nakazawaName: '中澤 英治',
    nakazawaSub: 'Eiji Nakazawa',
    careerTitle: '略　歴',
    specialtyTitle: '専門分野',
    kamigakiCareer: [
      { y: '1995年', d: ['神戸大学大学院医学研究科修了。', 'その後、国立神戸病院 外科、神戸大学医学部附属病院 第一外科などを経て'] },
      { y: '2010年', d: ['瀬田クリニック大阪クリニック院長'] },
      { y: '2012年', d: ['医療法人社団滉志会瀬田クリニックグループ', '臨床研究センター長(現任)'] },
      { y: '2018年', d: ['順天堂大学 次世代細胞・免疫治療学講座 特任教授'] },
      { y: '2023年', d: ['順天堂大学 健康総合科学先端研究機構 次世代細胞 免疫治療学プロジェクト 特任教授(現任)'] },
      { y: '2023年', d: ['医療法人社団 天裕会 理事長就任'] },
    ],
    kamigakiSpecialty: '消化器がん、特に肝胆膵外科領域を専門としてがん治療を長年担っています。近年分子生物学や免疫学が飛躍的に発展した事に伴い、がん標準的治療と先端的治療の併用治療の研究開発及び治療を専門に実施しています。',
    nakazawaCareer: [
      { y: '1973年 3月', d: ['日本医科大学卒業'] },
      { y: '1974年 1月', d: ['日本医科大学放射線科入局'] },
      { y: '1981年 4月', d: ['中澤病院開業（広島市）'] },
      { y: '2021年 5月', d: ['中澤病院閉院'] },
      { y: '2022年 6月', d: ['のぞみクリニック築地院長'] },
    ],
    facilityTitle: '施設・設備の紹介',
    reception: '受付',
    examRoom: '診察室',
    bloodRoom: '採血室',
  },
  zh: {
    aboutTitle: '关于本院',
    greetTitle: '致辞',
    greetingPc: '本院于令和3年（2021年）10月开业。作为普通内科，本院承担着患者获得适当医疗服务的第一窗口的职责，致力于成为当地居民的“家庭医生”，用心提供亲切、细致的初期诊疗。由于中央区筑地的地域特点，前来就诊的患者背景各不相同。本院努力根据每位患者的个人背景提供相应的治疗。不仅是诊察时的疑问或担忧，无论多么细小的事情，都欢迎您随时咨询。',
    greetingM: '本院于令和3年（2021年）10月开业。作为普通内科，本院承担着患者获得适当医疗服务的第一窗口的职责，致力于成为当地居民的“家庭医生”，用心提供亲切、细致的初期诊疗。由于中央区筑地的地域特点，前来就诊的患者背景各不相同。本院努力根据每位患者的个人背景提供相应的治疗。不仅是诊察时的疑问或担忧，无论多么细小的事情，都欢迎您随时咨询。',
    chairmanTitle: '理事长简介',
    chairmanPos: '理事长',
    kamigakiName: '神垣 隆',
    kamigakiSub: 'Takashi Kamigaki',
    directorTitle: '院长简介',
    directorPos: '院长',
    nakazawaName: '中澤 英治',
    nakazawaSub: 'Eiji Nakazawa',
    careerTitle: '简历',
    specialtyTitle: '专业领域',
    kamigakiCareer: [
      { y: '1995年', d: ['神户大学研究生院医学研究科毕业。', '此后，历经国立神户医院外科、神户大学医学部附属医院第一外科等'] },
      { y: '2010年', d: ['濑田诊所大阪诊所 院长'] },
      { y: '2012年', d: ['医疗法人社团滉志会 濑田诊所集团', '临床研究中心主任（现任）'] },
      { y: '2018年', d: ['顺天堂大学 新一代细胞·免疫治疗学讲座 特聘教授'] },
      { y: '2023年', d: ['顺天堂大学 健康综合科学尖端研究机构 新一代细胞免疫治疗学项目 特聘教授（现任）'] },
      { y: '2023年', d: ['就任医疗法人社团 天裕会 理事长'] },
    ],
    kamigakiSpecialty: '长年从事消化系统癌症的治疗，尤其专攻肝胆胰外科领域。近年来，随着分子生物学和免疫学的飞跃发展，专门从事癌症标准治疗与尖端治疗联合疗法的研究开发及治疗。',
    nakazawaCareer: [
      { y: '1973年 3月', d: ['毕业于日本医科大学'] },
      { y: '1974年 1月', d: ['进入日本医科大学放射科'] },
      { y: '1981年 4月', d: ['开设中泽医院（广岛市）'] },
      { y: '2021年 5月', d: ['中泽医院停业'] },
      { y: '2022年 6月', d: ['のぞみクリニック築地 院长'] },
    ],
    facilityTitle: '设施与设备介绍',
    reception: '前台',
    examRoom: '诊室',
    bloodRoom: '采血室',
  },
  en: {
    aboutTitle: 'About Our Clinic',
    greetTitle: 'Greeting',
    greetingPc: 'Our clinic opened in October 2021 (Reiwa 3). As a general internal medicine clinic, we serve as the first point of contact for receiving appropriate medical care, and we strive to provide caring, attentive primary care so that we can become a trusted "family doctor" for the people of our community. Because of the character of the Tsukiji area of Chuo-ku, we see patients from many different backgrounds, and we do our best to provide treatment suited to each patient\'s individual background. Please feel free to consult us not only about questions or concerns you have during your examination, but about anything at all, however small.',
    greetingM: 'Our clinic opened in October 2021 (Reiwa 3). As a general internal medicine clinic, we serve as the first point of contact for receiving appropriate medical care, and we strive to provide caring, attentive primary care so that we can become a trusted "family doctor" for the people of our community. Because of the character of the Tsukiji area of Chuo-ku, we see patients from many different backgrounds, and we do our best to provide treatment suited to each patient\'s individual background. Please feel free to consult us not only about questions or concerns you have during your examination, but about anything at all, however small.',
    chairmanTitle: 'About Our Chairman',
    chairmanPos: 'Chairman',
    // 英語ではローマ字名をメイン表示にし、漢字名をサブ表示にする
    kamigakiName: 'Dr. Takashi Kamigaki',
    kamigakiSub: '神垣 隆',
    directorTitle: 'About Our Director',
    directorPos: 'Director',
    nakazawaName: 'Dr. Eiji Nakazawa',
    nakazawaSub: '中澤 英治',
    careerTitle: 'Career',
    specialtyTitle: 'Specialty',
    kamigakiCareer: [
      { y: '1995', d: ['Completed the Graduate School of Medicine, Kobe University.', 'Subsequently worked at the Department of Surgery, National Kobe Hospital, the First Department of Surgery, Kobe University Hospital, and elsewhere'] },
      { y: '2010', d: ['Director, Seta Clinic Osaka'] },
      { y: '2012', d: ['Seta Clinic Group, Koshikai Medical Corporation', 'Head of the Clinical Research Center (current)'] },
      { y: '2018', d: ['Specially Appointed Professor, Department of Next-Generation Cell and Immune Therapy, Juntendo University'] },
      { y: '2023', d: ['Specially Appointed Professor, Next-Generation Cell and Immune Therapy Project, Juntendo Advanced Research Institute for Health Science, Juntendo University (current)'] },
      { y: '2023', d: ['Appointed Chairman of Tenyukai Medical Corporation'] },
    ],
    kamigakiSpecialty: 'He has been engaged in cancer treatment for many years, specializing in gastrointestinal cancers, particularly hepato-biliary-pancreatic surgery. With the dramatic advances in molecular biology and immunology in recent years, he specializes in the research, development and delivery of treatments that combine standard cancer therapy with advanced therapies.',
    nakazawaCareer: [
      { y: 'Mar. 1973', d: ['Graduated from Nippon Medical School'] },
      { y: 'Jan. 1974', d: ['Joined the Department of Radiology, Nippon Medical School'] },
      { y: 'Apr. 1981', d: ['Opened Nakazawa Hospital (Hiroshima City)'] },
      { y: 'May 2021', d: ['Closed Nakazawa Hospital'] },
      { y: 'Jun. 2022', d: ['Director, Nozomi Clinic Tsukiji'] },
    ],
    facilityTitle: 'Facilities & Equipment',
    reception: 'Reception',
    examRoom: 'Examination Room',
    bloodRoom: 'Blood Collection Room',
  },
}

export default {
  name: "About",
  components: {MFooter, MAccess, MIntroduce, MTop, HomeAccess, PageFooter, PageHeader},
  data() {
    return {
      pageWidth:0,
    }
  },
  computed: {
    t() {
      return T[this.$lang] || T.ja
    },
    // スマホ版の施設スライド（表示名は言語に合わせる）
    cardList() {
      const t = this.t
      return [
        { 'picUrl': 'img_hope01.png', 'name': t.reception, 'details': [''] },
        { 'picUrl': 'img_hope02.png', 'name': t.examRoom, 'details': [] },
        { 'picUrl': 'img_hope03.png', 'name': t.bloodRoom, 'details': [] },
      ]
    },
  },
  methods: {
    getFooterTop() {
      // let pageHeight = document.documentElement.offsetHeight;//页面高度
      // let topper = document.getElementById('about').children[0]
      // let topperHeight = topper.offsetHeight;//除了footer的，上半部分组件的高度
      //
      // let diffHeight = pageHeight - topperHeight
      // if (diffHeight < 0) {
      //   return;
      // }
      // let footerHeight = document.getElementById('footer').scrollHeight + 10
      // topper.style.marginBottom = (diffHeight-footerHeight) + 'px';
      this.pageWidth = document.documentElement.offsetWidth;
    }
  },
  beforeMount() {
    // 刚加载页面时，获取高度
    this.getFooterTop()
  },
  mounted() {
    // 调整页面高度时，获取高度
    window.onresize = () => {
      this.getFooterTop()
    }
  }
}
</script>

<style scoped>

.clinic-info {
  margin-top: 5rem;
}
.title {
  text-align: center;
  margin-top: 5rem;
  font-size: 24px;
  font-weight: bold;
  color: #333;
  letter-spacing: 5px;
}

.introduction {
  margin-top: 30px;
  padding: 60px;
  font-size: 14px;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  background-color: #FFFFFF;
  color: #333;
  line-height: 36px;
}

.doctor {
  display: flex;
  margin: 2rem 0;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}


.doctor_greeting {
  display: flex;
  margin: 2rem 0;
}
.doctor .photo, .doctor .profile {
  width: 50%;
  padding: 3rem;

  display: flex;
  flex-direction: column;
  /*justify-content: space-between;*/
}
.doctor .photo {
  background-color: #ffffff;
  border-radius: 10px 0 0 10px;
  align-items: center;
}
.doctor .photo>div:nth-child(1) {
  display: inline-block;
  position: relative;
  width: 406px;
  /* height: 250px; */
}
.doctor .photo>div:nth-child(1) img {
  width: 100%;
  height: 100%;
  border-radius: 40px;
}
.doctor .photo>div:nth-child(2) {
  /* margin-top: 1rem; */
  margin-top: 2.5rem;
}
.doctor .photo .position {
  font-size: 20px;
  color: #333;
  letter-spacing: 4px;
}
.doctor .photo .divider {
  height: 0;
  width: 60%;
  margin: 10px;
  border: 2px solid #1796C4;
}
.doctor .photo .name {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  letter-spacing: 5px;
}
.doctor .photo .name-en {
  font-size: 16px;
  letter-spacing: 6px;
  color: #707070;
  margin-top: 6px;
}
.doctor .profile {
  background-color: #EDF7FC;
  border-radius: 0 10px 10px 0;
}
.doctor .profile .sub-title {
  font-weight: bold;
  font-size: 20px;
  color: #333;
  letter-spacing: 4px;
}
.doctor .profile-detail {
  margin-top: 40px;
  font-size: 14px;
  color: #333;
  line-height: 32px;
  text-align: left;
}
.doctor .profile .experience {
  color: #333;
  letter-spacing: 4px;
  font-size: 20px;
  font-weight: bold;
  margin-top: 1rem;
}
.doctor .profile .detail {
  margin-top: 1rem;
  color: #333;
  line-height: 20px;
  font-size: 14px;
  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-row-gap: 10px;
}
.doctor .society {
  font-weight: bold;
  font-size: 20px;
  color: #333;
  margin-top: 2rem;
  letter-spacing: 4px;
}
.doctor .society-detail {
  margin-top: 20px;
  font-size: 14px;
  color: #333;
  line-height: 28px;
}

/* 施設の紹介 */
.facility {
  margin: 60px 40px;
}
.facility .title {
  color: #535353;
  font-size: 24px;
  font-weight: bold;
  text-align: left;
}
.introduce-wrap {
  margin-top: 30px;
  display: flex;
  justify-content: space-around;
}
/* 写真は1枚だけの段（採血室）も半分の幅にする */
.introduce {
  flex: 0 1 50%;
}
.introduce .img img {
  width: 100%;
  height: 100%;
}
.introduce .text {
  color: #535353;
  font-size: 20px;
  text-align: center;
  letter-spacing: 4px;
  margin-top: 20px;
}

/*手机端*/
.m-tittle {
  text-align: center;
  margin: 2rem 0;
  font-size: 24px;
  font-weight: bold;
  color: #333;
  letter-spacing: 5px;
}
.m-detail {
  background-color: #FFFFFF;
  text-indent: 1rem;
  line-height: 25px;
  padding: 1rem;
  font-size: 16px;
  color: #333;
}
.m-detail div:nth-child(1) {
  margin-bottom: 0.5rem;
}

.m-doctor {
  background-color: #FFFFFF;
  padding: 1rem 2rem;
}
.m-doctor .m-photo>img {
  width: 100%;
  height: 100%;
  border-radius: 30px;
}
.m-photo .position {
  text-align: center;
  margin: 1rem;
  font-size: 20px;
  color: #333;
  letter-spacing: 4px;
}
.m-photo .divider {
  height: 0;
  width: 80%;
  margin: 10px auto;
  border: 2px solid #1796C4;
}
.m-photo .name {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  letter-spacing: 5px;
  text-align: center;
}
.m-photo .name-en {
  font-size: 16px;
  letter-spacing: 6px;
  color: #707070;
  margin-top: 6px;
  text-align: center;
}
.m-photo .profile-detail {
  color: #333;
  margin-top: 1rem;
  line-height: 25px;
}
.m-photo .profile-detail>div:nth-child(1),
.m-photo .profile-detail>div:nth-child(3) {
  font-weight: bold;
}
.m-photo .profile-detail>div:nth-child(2) {
  margin-bottom: 1rem;
}
.m-subTittle {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #333;
  letter-spacing: 4px;
  margin-top: 2rem;
  margin-bottom: 1rem;
}
.m-doctor .sub-experience {
  font-size: 14px;
  line-height: 20px;
  color: #333;

  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-row-gap: 10px;
}
.m-doctor .society-detail {
  font-size: 14px;
  line-height: 30px;
  color: #333;
}

.m_greeting{
  line-height: 30px;
}

.greeting{
  line-height: 40px;
}

.card {
  background-color: #fff;
  width: 90%;
  height: 300px;
  margin: 0 auto 1.5rem;

  display: flex;
  flex-direction: column;
  align-items: center;
}
.card .pic {
  width: 100%;
}
.card .pic img {
  width: 100%;
  height: 100%;
}
.card .sub-name {
  color: #333;
  font-size: 14px;
  letter-spacing: 3px;
  margin: 1rem 0;
}
.card .detail>div {
  color: #333;
  font-size: 12px;
  line-height: 18px;
}
.ll div{
  line-height: 26px;
}
.side-text{
  height: fit-content;
  margin-left: 50px;
  margin-right: 50px;
  margin-bottom: auto;
}

.sennmonn{
  margin-top: 1rem;
  color: #333;
  line-height: 26px;
  font-size: 14px;
}

</style>
